import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import {
  BILLING_STATUS_LABELS,
  PLAN_KEYS,
  PLAN_LABELS,
  PLAN_STATUS_LABELS,
  REPORTS_ACCESS_LABELS,
  formatPlanLimit,
  planBadgeClass,
  trackDealerPlanEvent,
} from "../../../constants/automapDealerPlanConstants";
import { TRIAL_STATUS_LABELS } from "../../../constants/automapDealerTrialConstants";
import { fetchPlanDealers } from "../../../services/automapDealerPlanApi";
import { AdminPlansNav } from "./AdminPlansShared";

export default function AdminPlanDealersPage() {
  const [dealers, setDealers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [filters, setFilters] = useState({
    planKey: "",
    planStatus: "",
    trialStatus: "",
    billingStatus: "",
    city: "",
    readyToConvert: "",
    overListingLimit: "",
    nearLeadLimit: "",
    customPlan: "",
    featuredEligible: "",
  });

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const payload = await fetchPlanDealers(filters);
      setDealers(payload.dealers || []);
      trackDealerPlanEvent("admin_plan_dealer_list_viewed", filters);
    } catch (err) {
      setError(err.message || "Error al cargar.");
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    load();
  }, [load]);

  const setFilter = (key, value) => setFilters((prev) => ({ ...prev, [key]: value }));

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Planes" title="Concesionarios por plan" description="Asignación, límites y estado de billing placeholder." />
      <AdminAutomotiveNav active="plans" />
      <AdminPlansNav active="dealers" />
      <main className="admin-console__main wrap">
        <div className="admin-filters" style={{ display: "flex", flexWrap: "wrap", gap: "0.75rem", marginBottom: "1rem" }}>
          <select value={filters.planKey} onChange={(e) => setFilter("planKey", e.target.value)}>
            <option value="">Plan</option>
            {PLAN_KEYS.map((k) => <option key={k} value={k}>{PLAN_LABELS[k]}</option>)}
          </select>
          <select value={filters.planStatus} onChange={(e) => setFilter("planStatus", e.target.value)}>
            <option value="">Estado plan</option>
            {Object.entries(PLAN_STATUS_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <select value={filters.trialStatus} onChange={(e) => setFilter("trialStatus", e.target.value)}>
            <option value="">Trial</option>
            {Object.entries(TRIAL_STATUS_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <select value={filters.billingStatus} onChange={(e) => setFilter("billingStatus", e.target.value)}>
            <option value="">Billing</option>
            {Object.entries(BILLING_STATUS_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <input placeholder="Ciudad" value={filters.city} onChange={(e) => setFilter("city", e.target.value)} />
          <select value={filters.readyToConvert} onChange={(e) => setFilter("readyToConvert", e.target.value)}>
            <option value="">Listo convertir</option>
            <option value="true">Sí</option>
          </select>
          <select value={filters.overListingLimit} onChange={(e) => setFilter("overListingLimit", e.target.value)}>
            <option value="">Sobre límite listings</option>
            <option value="true">Sí</option>
          </select>
          <select value={filters.nearLeadLimit} onChange={(e) => setFilter("nearLeadLimit", e.target.value)}>
            <option value="">Cerca límite leads</option>
            <option value="true">Sí</option>
          </select>
          <select value={filters.customPlan} onChange={(e) => setFilter("customPlan", e.target.value)}>
            <option value="">Custom</option>
            <option value="true">Sí</option>
          </select>
          <select value={filters.featuredEligible} onChange={(e) => setFilter("featuredEligible", e.target.value)}>
            <option value="">Destacado elegible</option>
            <option value="true">Sí</option>
          </select>
        </div>
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading && !error ? (
          <div className="import-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Concesionario</th>
                  <th>Ciudad</th>
                  <th>Plan</th>
                  <th>Estado</th>
                  <th>Trial</th>
                  <th>Listings</th>
                  <th>Leads mes</th>
                  <th>Reportes</th>
                  <th>Billing</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {dealers.map((row) => (
                  <tr key={row.dealerId}>
                    <td>{row.businessName}</td>
                    <td>{row.city || "—"}</td>
                    <td><span className={`admin-badge ${planBadgeClass(row.planKey)}`}>{row.planName}</span></td>
                    <td>{PLAN_STATUS_LABELS[row.planStatus] || row.planStatus}</td>
                    <td>{TRIAL_STATUS_LABELS[row.trialStatus] || row.trialStatus || "—"}</td>
                    <td>{row.activeListings}/{formatPlanLimit(row.listingLimit)}</td>
                    <td>{row.leadsThisMonth}/{formatPlanLimit(row.leadLimitMonthly)}</td>
                    <td>{REPORTS_ACCESS_LABELS[row.reportsAccess] || row.reportsAccess || "—"}</td>
                    <td>{BILLING_STATUS_LABELS[row.billingStatus] || row.billingStatus}</td>
                    <td><Link to={`/admin/dealers/${row.dealerId}/plan`}>Gestionar</Link></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
